import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { journeysEntryPoint } from '@atlassian/jira-spa-apps-project-settings-servicedesk-journeys/entrypoint.tsx';

export const journeysPageEntryPoint = createPageEntryPoint({
	main: journeysEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
